import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any


@Component({
  selector: 'addAcademicyearH',
  templateUrl: 'addAcademicyearH.component.html',
  styleUrls: ['addAcadamicyearH.component.scss'],

})
export class AddAcademicyearHComponent implements OnInit {

  display = "none";
  display1 = "none"
  public SchoolYear: any;
  public yearname: string = '';
  public yearnameupdate: string = '';
  public selectedYear: string = '';
  public yearIdUpdate: string = '';


  public schoolId: any;
  public userId :string;

  constructor(private dataAnalyticsService: DataAnalyticsService, private messageService: MessageService,
    private noticeboardService: NoticeboardService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
  }



  ngOnInit() {
    this.getAcademicYear()

  }
//----------------------------------------------Get------------------------------------------------

  private getAcademicYear(){
    this.dataAnalyticsService.getAcadamicYearOfyears().finally(() => { }).subscribe(
      response => {
        this.SchoolYear = response['yearList'];
        this.SchoolYear.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));

        console.log('HigherEdchildbatch',this.SchoolYear)
      },
      error => {
        this.SchoolYear = [];
        console.error(error);
      });
  };
//----------------------------------------------Post------------------------------------------------

  postAcademicYear() {
    var payload = {
      YearName: this.yearname,
    };

    console.log("postacademicyear",payload);

    this.dataAnalyticsService
      .postAcadamicYear(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Academic Year Added Successfully",
          });
          this.display = "none";
          this.getAcademicYear();

          console.log(response);
        },
        (error) => {}
      );
  }
//----------------------------------------------Update------------------------------------------------
  updateAcademicYear() {
    var payload = {
      Id: this.yearIdUpdate,
      YearName: this.yearnameupdate,

    };

    console.log("postacademicyear",payload);

    this.dataAnalyticsService
      .updateAcadamicYear(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Academic Year Update Successfully",
          });
          this.display1 = "none";
          this.getAcademicYear();

          console.log(response);
        },
        (error) => {}
      );
  }


  AddAcademicyear() {
    this.display= "block"
  }

  EditAcademicyear(year: any) {
    this.yearnameupdate = year.AcademicYear;
    this.yearIdUpdate = year.YearId;
    this.display1= "block"
    this.selectedYear = year;

  }

  onCloseHandled() {
    this.display = "none";
    this.display1 = "none";
  }
    confirm(Id) {
      console.log(Id)
      // this.DeleteSubjects(Id);
      this.confirmationService.confirm({
        message: 'Are you sure that you want to perform this action?',
        accept: () => {
        //  this.DeleteAcdemicYears(Id);
        }
      });
    }




  setCurrentYear(selectedYear) {
    // First, set all years' isCurrentYear to 0
    this.SchoolYear.forEach(year => {
      year.Currentyear = 0;
    });

    // Then set the selected year's isCurrentYear based on its current value
    selectedYear.Currentyear = selectedYear.Currentyear === 1 ? 0 : 1;

    console.log("Updated Years: ", this.SchoolYear);

    let payload = {
      "Id": selectedYear.YearId,
      "CurrentYear": 1
    }


    this.dataAnalyticsService
      .updateCurrentYear(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Current Academic Year Updated Successfully",
          });
          console.log(response);
        },
        (error) => {}
      );



  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/AddAcademicyear/addAcademicyearH.component.ts